import React from 'react';
import TransferList from 'app/components/district/transfers/TransferList';
import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchAllTransfers } from 'app/queries/districtTransfers';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import InfiniteScrollTrigger from 'app/components/infiniteScroll/InfiniteScrollTrigger';
import InfiniteScrollLoadingIndicator from 'app/components/district/InfiniteScrollLoadingIndicator';
import InfiniteScrollErrorMessage from 'app/components/district/InfiniteScrollErrorMessage';
import SeoLinks from 'app/components/seo/SeoLinks';
export default function AllTransfers(_ref) {
  let {
    initialState,
    hideSeoLinks = false
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const dispatch = useDispatch();
  const {
    data,
    isLoading,
    isError,
    fetchNextPage,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery({
    queryKey: ['district-transfers', {
      districtSlug
    }],
    queryFn: _ref2 => {
      let {
        pageParam = null
      } = _ref2;
      return fetchAllTransfers(districtSlug, pageParam, dispatch);
    },
    getNextPageParam: lastPage => {
      if (lastPage.links.next) {
        return lastPage.links.next;
      }
      return undefined;
    },
    initialData: initialState ? {
      pages: [initialState],
      pageParams: [undefined]
    } : undefined
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, {
      message: "Transfers werden geladen..."
    });
  }
  if (isError && !(data !== null && data !== void 0 && data.pages.length)) {
    return /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
      onRetry: refetch,
      entityName: "Transfers"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TransferList, {
    data: data,
    "data-sentry-element": "TransferList",
    "data-sentry-source-file": "AllTransfers.tsx"
  }), /*#__PURE__*/React.createElement(InfiniteScrollTrigger, {
    onTrigger: fetchNextPage,
    "data-sentry-element": "InfiniteScrollTrigger",
    "data-sentry-source-file": "AllTransfers.tsx"
  }), isFetchingNextPage ? /*#__PURE__*/React.createElement(InfiniteScrollLoadingIndicator, {
    message: "Weitere Transfers werden geladen..."
  }) : isError ? /*#__PURE__*/React.createElement(InfiniteScrollErrorMessage, {
    onRetry: refetch,
    entityName: "Transfers"
  }) : hideSeoLinks ? null : /*#__PURE__*/React.createElement(SeoLinks, {
    data: data.pages
  }));
}